import { FmsApi } from "../fmsapi"
import type {
  iCPY_in_CreatorBooking,
  iCPY_sr_BookCoverVote,
  iCPY_sd_BookCoverCompany,
  iCPY_sd_CreatorBooking,
  iCPY_in_BookCoverVote,
  MasterGroupType,
  iCPY_sr_exhibitorInfo_BMS,
  iCPY_in_Staff_BMS,
} from "../fmsapi"

import type {
  COM_sd_MasterCode,
  CPY_dn_BookCoverVote,
  CPY_in_CreatorBooking,
  CPY_in_Staff_BMS,
  CPY_sd_BookCoverCompany,
  CPY_sr_BookCoverCompany,
  CPY_sr_BookCoverVote,
  CPY_sr_exhibitorInfo_BMS,
} from "../models/responsedto"
import BaseController from "./base"

export class CompanyController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "company")
  }

  public async COM_sd_MasterCode(masterCode: number, level: MasterGroupType | null = null): Promise<COM_sd_MasterCode[]> {
    return await this.callApi("COM_sd_MasterCode", { masterCode, level })
  }

  public async CPY_sd_BookCoverCompany(params: iCPY_sd_BookCoverCompany): Promise<CPY_sd_BookCoverCompany> {
    return await this.getCallApi("CPY_sd_BookCoverCompany", params)
  }

  public async CPY_sr_BookCoverVote(params: iCPY_sr_BookCoverVote): Promise<CPY_sr_BookCoverVote> {
    return await this.getCallApi("CPY_sr_BookCoverVote", params)
  }

  public async CPY_sd_CreatorBooking(params: iCPY_sd_CreatorBooking): Promise<CPY_sr_BookCoverVote> {
    return await this.getCallApi("CPY_sd_CreatorBooking", params)
  }

  public async CPY_sr_BookCoverCompany(BOOK_COVER_COMPANY_ID: number): Promise<CPY_sr_BookCoverCompany> {
    return await this.getCallApi("CPY_sr_BookCoverCompany", { BOOK_COVER_COMPANY_ID: BOOK_COVER_COMPANY_ID })
  }

  public async CPY_in_CreatorBooking(params: iCPY_in_CreatorBooking): Promise<CPY_in_CreatorBooking> {
    return await this.callApi("CPY_in_CreatorBooking", params)
  }

  public async CPY_in_BookCoverVote(params: iCPY_in_BookCoverVote): Promise<CPY_in_CreatorBooking> {
    return await this.callApi("CPY_in_BookCoverVote", params)
  }

  public async CPY_dn_BookCoverVote(BOOK_COVER_VOTE_ID: number): Promise<CPY_dn_BookCoverVote> {
    return await this.callApi("CPY_dn_BookCoverVote", { BOOK_COVER_VOTE_ID })
  }

  public async CPY_sr_exhibitorInfo_BMS(params: iCPY_sr_exhibitorInfo_BMS): Promise<CPY_sr_exhibitorInfo_BMS> {
    let data = await this.callApi<CPY_sr_exhibitorInfo_BMS[]>("CPY_sr_exhibitorInfo_BMS", params);
    return data[0];
  }

  public async CPY_in_Staff_BMS(params: iCPY_in_Staff_BMS): Promise<CPY_in_Staff_BMS> {
    return await this.callApi("CPY_in_Staff_BMS", params)
  }
}
